import React, { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { PageHeader, EmptyState, CapabilityChip } from "@/components/shared";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { Trash2, LayoutTemplate } from "lucide-react";
import { toast } from "sonner";

export default function Templates() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/templates").then((r) => setItems(r.data.items)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  return (
    <div className="space-y-5">
      <PageHeader title="Templates" desc="Reusable bot configurations. Tokens are never copied." testId="templates-header" />
      {!items ? <Skeleton className="h-40 w-full" /> : items.length === 0 ? (
        <div className="bg-card border border-border rounded-lg"><EmptyState icon={LayoutTemplate} title="No templates yet"
          desc="Save a template from any bot (Bot → ⋯). Templates capture commands, profile & menu — never secrets." testId="empty-templates" /></div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((t) => (
            <div key={t.id} className="bg-card border border-border rounded-lg p-4 space-y-2" data-testid={`template-${t.id}`}>
              <div className="flex items-start justify-between"><h3 className="font-semibold">{t.name}</h3>
                <Button variant="ghost" size="icon" className="h-7 w-7 text-rose-500" onClick={async () => { await api.delete(`/templates/${t.id}`); load(); }} data-testid={`btn-del-template-${t.id}`}><Trash2 size={14} /></Button></div>
              <p className="text-xs text-muted-foreground">{t.description || "No description"}</p>
              <div className="flex items-center gap-2 text-xs"><span className="mono">{(t.commands || []).length} commands</span><CapabilityChip chip="Direct" /></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
